import styled from "styled-components";
import { shade } from "polished";

// Libraries
import { TextField } from "@libraries/mui";

const Container = styled.div`
  height: 375px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const MessagesContent = styled.div`
  max-height: 310px;
  overflow-y: scroll;
  padding-right: 5px;
`;

const InputContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.primary};
`;

const InputContent = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Input = styled(TextField)`
  //padding: 5px;
  width: 90%;

  .MuiOutlinedInput-root {
    border-radius: 30px !important;
    font-size: 14px !important;
  }

  & .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.colors.primary};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const SendButton = styled.button`
  color: ${({ theme }) => theme.colors.primary};
  border: none;
  cursor: pointer;
  background: none;
  transition: color 0.5s;

  &:hover {
    color: ${({ theme }) => shade(0.2, theme.colors.primary)};
  }

  &:disabled {
    color: #a3a3a3;
    cursor: not-allowed;
  }
`;

export {
  Container,
  MessagesContent,
  InputContainer,
  InputContent,
  Input,
  SendButton
};
